import type {
  ChatsChannelBase,
  ChatsChannelSetting
} from '../../../constants/types';
import { ChatsChannelType } from '../../../constants/types';
import { getChatIcon } from '../../helpers';

export const getCustomSettings = ({
  customButtonLink,
  customButtonIcon,
  customButtonText
}: Partial<ChatsChannelBase>) => {
  if (!customButtonLink) return null;

  const { rawValue, target } = customButtonLink;
  const icon = customButtonIcon?.url
    ? getChatIcon(ChatsChannelType.custom, customButtonIcon.url)
    : null;

  return {
    provider: ChatsChannelType.custom,
    title: customButtonText || 'Custom Contact',
    link: { url: rawValue, options: { target, withFeatures: false } },
    icon,
    color: 'rgb(10, 49, 102)'
  } as ChatsChannelSetting;
};
